import { initialize } from "../src/utils/initialize";
initialize();
/**
 * The `mount` method must be imported and resolved after initialization to make sure critical global context(s) are properly set before usage.
 * To prevent adding extra network call due to dynamic import usage, the webpackMode magic comment is used and set to `eager` to allow importing eagerly the dynamically imported module without generating extra chunk.
 * @see {@link https://webpack.js.org/api/module-methods/#webpackmode Webpack documentation}.
 */
const { mount } = await import(
/* webpackMode: "eager" */
"./mount");
mount();
